import React from "react";
import styles from "./Game.module.css";
import Icecream from "./components/Icecream";
import Header from "./components/Header";
import Lottery from "./components/Lottery";
import Bank from "./components/Bank";
import Stocks from "./components/Stocks";

import { useStateContext } from "../lib/StateContext";

function Game() {
  const [state] = useStateContext();

  return (
    <section className="Game-Page">
      <Header />

      <section className="status"></section>

      <div className={styles.gameTiles}>
        <Icecream className={styles.tile} />

        {state.player.xp > 50 && <Lottery className={styles.tile} />}
        <div>
          {(state.monies.cash > state.bank.unlocks ||
            state.bank.isUnlocked) && <Bank className={styles.tile} />}
          {(state.monies.bank > state.stocks.unlocks ||
            state.stocks.invested > 0) && <Stocks className={styles.tile} />}
        </div>
      </div>
    </section>
  );
}

export default Game;
